module.exports = __webpack_public_path__ + "img/software_main.37f998b0.png";